import classNames from 'classnames';
import React from 'react';
import { TestId } from '@trello/test-ids';
import styles from './HeaderButton.less';
import { Button } from '@trello/nachos/button';
import { useBoardBackground } from 'app/src/components/Theme';

interface HeaderButtonProps {
  ariaLabel?: string;
  children?: React.ReactNode;
  className?: string;
  icon?: JSX.Element;
  onClick: React.MouseEventHandler;
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
  testId?: TestId;
  title?: string;
}

export const HeaderButton = React.forwardRef<
  HTMLButtonElement,
  HeaderButtonProps
>(
  (
    {
      ariaLabel,
      children,
      className,
      icon,
      onClick,
      onMouseEnter,
      onMouseLeave,
      testId,
      title,
    },
    ref,
  ) => {
    const { backgroundBrightness } = useBoardBackground();

    return (
      <Button
        appearance={
          backgroundBrightness === 'dark' ? 'transparent' : 'transparent-dark'
        }
        aria-label={ariaLabel}
        className={classNames(styles.headerButton, className)}
        data-test-id={testId}
        ref={ref}
        title={title}
        onClick={onClick}
        iconBefore={
          icon &&
          React.cloneElement(icon, {
            dangerous_className: styles.headerButtonIcon,
          })
        }
      >
        {children}
      </Button>
    );
  },
);
